import { css, html } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { when } from "lit/directives/when.js";
import { CLOSE_EVENT_NAME, OPEN_EVENT_NAME } from "../../configuration/constants.js";
import { defineComponent } from "../../configuration/utils.js";
import { coreVar, semanticVar } from "../styles.js";
import { NavItem } from "./NavItem.js";
export class NavSection extends NavItem {
    constructor() {
        super();
        this.renderExpandIcon = () => {
            return when(this.isOpen, this.renderExpandDownIcon, this.renderExpandRightIcon);
        };
        this.handleClick = (e) => {
            e.preventDefault();
            // When this is an app section type, and it's highlighted (meaning it has the current app),
            // we can safely toggle the open state.
            if (this.isHighlighted) {
                this.isOpen = !this.isOpen;
                this.dispatchToggleEvent(this.isOpen);
            }
            else {
                this.dispatchToggleEvent(!this.isOpen);
            }
        };
        this.isOpen = false;
        this.expandStart = false;
    }
    render() {
        return html `
      <details ?open=${this.isOpen}>
        <summary
          class=${classMap(this.sectionClasses)}
          aria-label=${this.label}
          title=${this.label}
          @click=${this.handleClick}
        >
          ${when(this.expandStart, this.renderExpandIcon, () => html `
              <span class="icon">
                <slot name="icon"></slot>
              </span>
            `)}
          <span class="label">${this.label}</span>
          ${when(!this.expandStart, this.renderExpandIcon)}
        </summary>
        <ul>
          <slot></slot>
        </ul>
      </details>
    `;
    }
    get sectionClasses() {
        return {
            ...this.itemClasses,
            current: this.isCurrent,
        };
    }
    dispatchToggleEvent(newState) {
        if (newState) {
            this.dispatchEvent(new CustomEvent(OPEN_EVENT_NAME));
        }
        else {
            this.dispatchEvent(new CustomEvent(CLOSE_EVENT_NAME));
        }
    }
}
NavSection.properties = {
    ...NavItem.properties,
    isOpen: { type: Boolean, reflect: true, attribute: "is-open" },
    expandStart: { type: Boolean, reflect: true, attribute: "expand-start" },
};
NavSection.styles = [
    ...NavItem.styles,
    css `
      details:has(summary.current, summary.highlighted) {
        background-color: ${coreVar("color-gray-800")};
        border-radius: ${semanticVar("radius-lg")};

        summary.current + ul,
        summary.highlighted + ul {
          display: var(--label-display, block);
          padding-top: ${coreVar("spacing-1")};
          --lens-component-global-nav-list-item-hover-background-color: ${coreVar("color-gray-700")};
        }
      }
      details:has(summary.current, summary.highlighted) summary.highlighted {
        background-color: ${coreVar("color-gray-700")};
      }
      summary.current + ul,
      summary.highlighted + ul {
        display: var(--label-display, block);
        padding-top: ${coreVar("spacing-1")};
        --lens-component-global-nav-list-item-hover-background-color: ${coreVar("color-gray-700")};
      }
    `,
];
export const NAV_SECTION_TAG = "atlas-gn-nav-section";
defineComponent(NAV_SECTION_TAG, NavSection);
